import { createRoutine, promisifyRoutine } from 'redux-saga-routines';
import * as types from '../actions/types';
import { attachOperationProp } from './utils';

const commonPayloadCreators = {
  FAILURE: (payload, error) => ({ ...payload, error: error.message }),
};

export const deleteManagedSoundcastEpisodes = createRoutine(
  types.DELETE_MANAGED_SOUNDCAST_EPISODES,
  {
    ...commonPayloadCreators,
    TRIGGER: attachOperationProp('bulk-delete'),
  }
);

export const deleteManagedSoundcastEpisodesCreator = promisifyRoutine(
  deleteManagedSoundcastEpisodes
);

export const updateSoundcastEpisodesOrder = createRoutine(types.UPDATE_SOUNDCAST_EPISODES_ORDER, {
  ...commonPayloadCreators,
  TRIGGER: attachOperationProp('episode-order'),
});

export const updateSoundcastEpisodesOrderCreator = promisifyRoutine(updateSoundcastEpisodesOrder);

export const bulkActionEpisodes = createRoutine(types.BULK_ACTION_EPISODES, {
  ...commonPayloadCreators,
  TRIGGER: payload => {
    const { action = '' } = payload;
    return attachOperationProp(`bulk-${action}`)(payload);
  },
});

export const bulkActionEpisodesCreator = promisifyRoutine(bulkActionEpisodes);
